import { type PropsWithChildren } from 'react';

export const Thresholds = ({ children }: PropsWithChildren) =>
  children !== undefined && children !== null ? (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>{children}</>
  ) : null;

Thresholds['displayName'] = 'MeterBarLayout.Thresholds';
